export default __webpack_public_path__ + "static/media/call-add-gray.c563d112.svg";